export const getSelectedRiskLevel = (selectedValue, documentRiskLevels) => {
    const selectedDocumentRiskLevel = documentRiskLevels.find((documentRiskLevel) => documentRiskLevel.value === selectedValue);
    return (selectedDocumentRiskLevel) ? `${selectedDocumentRiskLevel.review_freq} ${selectedDocumentRiskLevel.unit} ` : '';
}

export const  getSelectedPrefixName = (selectedValue,documentCategories) => {
    const selectedDocumentPrefixName = documentCategories.find((documentCategories) => documentCategories.value === selectedValue);
    return (selectedDocumentPrefixName) ? `${selectedDocumentPrefixName.prefixName}` : '';
}